/**
 * Vehicle condition scale — shared across Pocket Mechanic and Auto Advisor flows.
 */
const CONDITIONS = [
  { value: 'Concours', description: 'Show-winning, museum quality, better than new' },
  { value: 'Excellent', description: 'Show-ready daily driver, no excuses, pride of ownership' },
  { value: 'Very Good', description: 'Clean driver, well-maintained, minor imperfections only' },
  { value: 'Good', description: 'Solid driver, some cosmetic wear, mechanically sound' },
  { value: 'Fair', description: 'Daily-able but needs attention, deferred maintenance evident' },
  { value: 'Running Project', description: 'Drives but incomplete, active restoration in progress' },
  { value: 'Non-Running Project', description: 'Needs major work, engine/trans issues, long-term build' },
  { value: 'Parts Car', description: 'Salvage, not roadworthy, donor vehicle only' },
];

export const PROJECT_CONDITIONS = ['Non-Running Project', 'Parts Car'];

export default CONDITIONS;
